import React from 'react'
import { NavLink, useLocation } from 'react-router'
import HomeTwoToneIcon from '@mui/icons-material/HomeTwoTone'
// Centralized lodash imports - much cleaner!
import { isEmpty } from '@/utils/lodash'
import { Divider } from '@mui/material'

const SharedPropertiesSection = (props) => {
  const { session, handlePortfolio } = props
  const location = useLocation()
  const sharedProperties = session?.me?.activeOrg?.sharedProperties
  const isActive = () => {
    if (location.pathname !== '/shared-properties') return false
    const storedPortfolio = localStorage.getItem('portfolio')
    return !storedPortfolio || storedPortfolio === 'null'
  }
  if (isEmpty(sharedProperties)) return null
  return (
    <>
      <Divider />
      <ul>
        <li>
          <NavLink
            id="leftNavLenderProperties"
            data-hf="nav-link-simple"
            data-nav-active={isActive() || undefined}
            onClick={() => handlePortfolio && handlePortfolio(null)}
            to="/shared-properties"
          >
            <span data-hf="sidebar-icon">
              <HomeTwoToneIcon />
            </span>
            Shared Properties
          </NavLink>
        </li>
      </ul>
    </>
  )
}

export default SharedPropertiesSection
